import {InputLabel, FormGroup, Paper, TextField, Typography, FormControl, Button, MenuItem, Select, FormControlLabel, Checkbox} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import { v4 as uuidv4 } from 'uuid';
import { fetchTripbyId, fetchSuppliersbyDest, fetchSuppliers} from "../api/customerapi";
import { updateTripdata} from "../api/customerapi";
import GetRole from "./user";
import { useAppData } from "./appDataContext.js";
import {destAirport, identifydest, DateCalc2,  getconvdate} from "./date.js"
//import {gettcs, gettcs2} from "./paymentupdate.js"

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textField2: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(30),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
      button2: {
        marginLeft: theme.spacing(5),
        marginRight: theme.spacing(10),   
        width: theme.spacing(20),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Trippayments = () => {

    const classes = useStyles();
    const currenturl=window.location.href;
    const urlarray=currenturl.split("/");
    const currentid=urlarray[urlarray.length-2];
    const [notax, setnotax] = useState(0);
    const [fdom, setfdom] = useState(0);
    const [onlyflight, setonlyflight] = useState(0);
    const [cpdata, setcpdata]=useState([])
    const [tripData, settripData] =useState({})
    const [spdata, setspdata]=useState([])
    const [sData, setsData]=useState([]);
    const [showpaymentdata, setshowpaymentdata]=useState(true);
    const { appData, loading } = useAppData();
    var {cuser, role}=GetRole();
    const addcp =() =>{
        //console.log(cpdata)
        
        setcpdata(cpdata.length==0? [{id:uuidv4()}]: [...cpdata,{id:uuidv4()}])
        
        
    }

    const removecp =() =>{
        //console.log(cpdata)
        setcpdata([...cpdata].slice(0,cpdata.length-1))
        
    }

    const addsp =() =>{
        //console.log(spdata)
        
        setspdata(spdata.length==0? [{id:uuidv4(), name:"Not Booked Yet"}]: [...spdata,{id:uuidv4(), name:"Not Booked Yet"}])
        
        
    }

    const removesp =() =>{
        //console.log(spdata)
        setspdata([...spdata].slice(0,spdata.length-1))
        
    }

    const getTrips = async (id) => {
        try{
        const data = await fetchTripbyId(id);
        settripData(data.data)
        setcpdata(data.data.cust_payments ? data.data.cust_payments : [])
        setspdata(data.data.supplier_payments ? data.data.supplier_payments : [])
        if("cust_payments" in data.data && data.data.cust_payments.length>0){
            showpaymentdata(false)
        }
    }catch(err){
        console.log(err)
      }
    }

    const getsuppliers = async ( ) => {
        try{
        //console.log(tripData.primary_destination)
        //const data = await fetchSuppliersbyDest(tripData.primary_destination);
        const data = await fetchSuppliers();
        const data2=data.data.filter(sup=>sup.supplier_destinations==tripData.primary_destination || sup.supplier_destinations=="All")
        setsData(data2)
    }catch(err){
        console.log(err)
      }
        
    }

    useEffect(() => {
        getTrips(currentid)
        
        
    }, [])
    useEffect(() => {
        
        getsuppliers()
        
    }, [tripData])

    //console.log(cpdata);

    let nd=DateCalc2(tripData.trip_start_date,7)
    var fupsomeDate = new Date(nd);
  
    fupsomeDate.setDate(fupsomeDate.getDate()); 
    const fupy=fupsomeDate.getFullYear()
    const fupm=(fupsomeDate.getMonth()+1) < 10? ("0"+(fupsomeDate.getMonth()+1)) : (fupsomeDate.getMonth()+1)
    const fupdt=fupsomeDate.getDate() <10 ? ("0"+fupsomeDate.getDate()) : fupsomeDate.getDate()
    const fupfinalDate2=(fupy+"-"+fupm+"-"+fupdt)

    const datechange =(e,tid) =>{
  
        const newdata=cpdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, date:e.target.value}
        //console.log(newitem)
        cpdata[tid]=newitem
        setcpdata(cpdata)
        //setdata([...data, data[tid]=newitem])
       // console.log(cpdata)
    }

    const amountchange =(e,tid) =>{
  
        const newdata=cpdata[tid]
        //console.log(tid)
        const newitem= {...newdata, amount:e.target.value}
        //console.log(newitem)
        cpdata[tid]=newitem
        setcpdata(cpdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata[tid])
        //gettaxes()
    }

    const statuschange =(e,tid) =>{
  
        const newdata=cpdata[tid]
        //console.log(e.target)
        const newitem= {...newdata, status:e.target.value}
        //console.log(newitem)
        cpdata[tid]=newitem
        setcpdata(cpdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const modechange =(e,tid) =>{
  
        const newdata=cpdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, mode:e.target.value}
        //console.log(newitem)
        cpdata[tid]=newitem
        setcpdata(cpdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const accountchange =(e,tid) =>{
  
        const newdata=cpdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, account:e.target.value}
        //console.log(newitem)
        cpdata[tid]=newitem
        setcpdata(cpdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }
    const detailschange =(e,tid) =>{
  
        const newdata=cpdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, details:e.target.value}
        //console.log(newitem)
        cpdata[tid]=newitem
        setcpdata(cpdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const spdatechange =(e,tid) =>{
  
        const newdata=spdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, date:e.target.value}
        //console.log(newitem)
        spdata[tid]=newitem
        setspdata(spdata)
        //setdata([...data, data[tid]=newitem])
       // console.log(cpdata)
    }

    const spamountchange =(e,tid) =>{
  
        const newdata=spdata[tid]
        //console.log(tid)
        const newitem= {...newdata, amount:e.target.value}
        //console.log(newitem)
        spdata[tid]=newitem
        setspdata(spdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata[tid])
    }

    const spstatuschange =(e,tid) =>{
  
        const newdata=spdata[tid]
        //console.log(e.target)
        const newitem= {...newdata, status:e.target.value}
        //console.log(newitem)
        spdata[tid]=newitem
        setspdata(spdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const spmodechange =(e,tid) =>{
  
        const newdata=spdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, mode:e.target.value}
        //console.log(newitem)
        spdata[tid]=newitem
        setspdata(spdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const spaccountchange =(e,tid) =>{
  
        const newdata=spdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, account:e.target.value}
        //console.log(newitem)
        spdata[tid]=newitem
        setspdata(spdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }
    const spdetailschange =(e,tid) =>{
  
        const newdata=spdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, details:e.target.value}
        //console.log(newitem)
        spdata[tid]=newitem
        setspdata(spdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const spnamechange =(e,tid) =>{
  
        const newdata=spdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, name:e.target.value}
        //console.log(newitem)
        spdata[tid]=newitem
        setspdata(spdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const sptypechange =(e,tid) =>{
  
        const newdata=spdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, businesstype:e.target.value}
        //console.log(newitem)
        spdata[tid]=newitem
        setspdata(spdata)
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const gettaxes=()=>{
    var taxes=0
    if(notax){
      taxes=0
    }else if(onlyflight){
      var nontaxprofit2=(((tripData.flight_sp?tripData.flight_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))+((tripData.visa_sp?tripData.visa_sp:0)-(tripData.visa_cp?tripData.visa_cp:0))+((tripData.anc_sp?tripData.anc_sp:0)-(tripData.anc_cp?tripData.anc_cp:0))+((tripData.extra_sp?tripData.extra_sp:0)-(tripData.extra_cp?tripData.extra_cp:0))+((tripData.cruise_sp?tripData.cruise_sp:0)-(tripData.cruise_cp?tripData.cruise_cp:0)))
      taxes=(nontaxprofit2-nontaxprofit2/1.18).toFixed(0)
    }else{
    
    var landpart=total()-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.cruise_cp?tripData.cruise_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_sp?tripData.extra_sp:0)-(tripData.flight_cp?tripData.flight_cp:0)
    if(tripData.land_sp>0){
      taxes=((landpart-landpart/1.05)+(((tripData.extra_sp?tripData.extra_sp:0)-(tripData.extra_cp?tripData.extra_cp:0))-(((tripData.extra_sp?tripData.extra_sp:0)-(tripData.extra_cp?tripData.extra_cp:0))/1.18))).toFixed(0)
    }else{
      var nontaxprofit=(((tripData.flight_sp?tripData.flight_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))+((tripData.visa_sp?tripData.visa_sp:0)-(tripData.visa_cp?tripData.visa_cp:0))+((tripData.anc_sp?tripData.anc_sp:0)-(tripData.anc_cp?tripData.anc_cp:0))+((tripData.extra_sp?tripData.extra_sp:0)-(tripData.extra_cp?tripData.extra_cp:0))+((tripData.cruise_sp?tripData.cruise_sp:0)-(tripData.cruise_cp?tripData.cruise_cp:0)))
      taxes=(nontaxprofit-nontaxprofit/1.18).toFixed(0)
    }
  }
    return taxes
  }
      
    //   const gettcs2=()=>{
    //     var t=identifydest(tripData.primary_destination)
    //     //var landpart=total()-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.cruise_cp?tripData.cruise_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.flight_cp?tripData.flight_cp:0)-gettcs()
    //     var convdate=""
    //     var landpart=(total()-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.cruise_cp?tripData.cruise_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.flight_cp?tripData.flight_cp:0))/1.05
    //     if(t && !notax && !onlyflight && !fdom){
    //       if(tripData.trip_status=="Converted"){
    //           convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-1].date:""
    //       }else if(tripData.trip_status=="Closed"){
    //         convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-2].date:""
    //       }
    //       if(new Date(convdate).getTime()<new Date("2023-04-01").getTime()){
    //         return 0
    //       }else{
    //         return landpart?Math.round((landpart)*0.05):0
    //       }
            
    //     }else{
    //         //console.log("DEF")
    //         //setprice({...price,tcs:0})
    //         return 0
    //     }
    //   }
    //   const gettcs2=()=>{
    //     var t=identifydest(tripData.primary_destination)
    //     //var landpart=total()-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.cruise_cp?tripData.cruise_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.flight_cp?tripData.flight_cp:0)-gettcs()
    //     var landpart=(total()-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.cruise_cp?tripData.cruise_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.flight_cp?tripData.flight_cp:0))/1.05
    //     if(t && !notax && !onlyflight && !fdom){
    //         //console.log("ABC")
           
    //         //return tripData.land_sp?Math.round((tripData.land_sp)*0.05):0
    //         return landpart?Math.round((landpart)*0.05):0
    //     }else{
    //         //console.log("DEF")
    //         //setprice({...price,tcs:0})
    //         return 0
    //     }
    //   }

    const handleSubmit =async (e) => {
        try{
        e.preventDefault();
        if(parseInt(tripData.flight_sp)+parseInt(tripData.visa_sp)+parseInt(tripData.anc_sp)+parseInt(tripData.extra_sp)+parseInt(tripData.cruise_sp)+parseInt(tripData.land_sp)+gettcs(tripData) !== total()){
            alert("Sum of customer payments do not match")
        }else if(parseInt(tripData.flight_cp)+parseInt(tripData.visa_cp)+parseInt(tripData.anc_cp)+parseInt(tripData.extra_cp)+parseInt(tripData.cruise_cp)+parseInt(tripData.land_cp) !==sptotal()){
            alert("Sum of supplier payments do not match")
        }else{
            var x=1
            for(let i = 0; i <cpdata.length-1; i++) {
                if(i>0 && new Date(cpdata[i].date).getTime()<new Date(cpdata[i-1].date).getTime()){
                  x=0
                  alert("Final installment date should be greater than previous dates. Installment dates should be in sequence");
                }
                
                if(i==1 && (role=="Sales"|| role=="TL") && new Date(cpdata[i].date).getTime()-new Date(cpdata[i-1].date).getTime()>1000*60*60*24*7){
                  x=0
                  alert("Second installment should be within 7 days of first installment and should cover the profit amount and the hotel amount");
                }
              }
              if(x){
        const finaltripData= {...tripData, cust_payments: cpdata, supplier_payments:spdata, taxes:gettaxes()};

        // const addhotelResponse= await addHotel(finalhotelData);
        //console.log(sData);
        //console.log(finaltripData);
        const updatetripResponse= await updateTripdata(tripData._id, finaltripData);
        
        if(updatetripResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Payment data created for trip with trip id "+updatetripResponse.data.trip_id);
            window.location = ("/tripdataentry/"+updatetripResponse.data.trip_id+"/paymentupdate");
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
    }
    }  
}catch(err){
    console.log(err)
  }
    }
    const total=() => {
        let sum =0
        if(cpdata.length==0){
            return sum;
        }else{
            cpdata.map(item => item.amount ?  !(item.status == "Refund" || item.status=="Credit Note")? sum=sum+parseInt(item.amount): sum=sum-parseInt(item.amount) : sum)
            return sum;
        }
    }

    const pending=() => {
        let sum =0
        if(cpdata.length==0){
            return sum;
        }else{
            cpdata.map(item => item.amount && item.status=="Pending" ? sum=sum+parseInt(item.amount): sum)
            return sum;
        }
    }

    const sppending=() => {
        let sum =0
        if(spdata.length==0){
            return sum;
        }else{
            spdata.map(item => item.amount && item.status=="Pending" ? sum=sum+parseInt(item.amount): sum)
            return sum;
        }
    }

    const sptotal=() => {
        let sum =0
        if(spdata.length==0){
            return sum;
        }else{
            spdata.map(item => item.amount ? !(item.status == "Refund" || item.status=="Refund Due" || item.status=="Refund claim by internal team") ? sum=sum+parseInt(item.amount): sum=sum-parseInt(item.amount) : sum)
            return sum;
        }
    }
    const getsuppliertype=(name)=>{
        const type=sData.filter(sup => sup.supplier_name==name)
         return type.length>0?type[0].supplier_type:""
      }
    
      const changelandsp=(e)=>{
        settripData({ ...tripData, land_sp: e.target.value })
        gettaxes()
        gettcs(tripData)
      }
     
      const gettcs=()=>{
        var t=identifydest(tripData.primary_destination)
        if(tripData.primary_destination=="Maldives" && new Date(getconvdate(tripData)).getTime()>new Date("2025-10-01").getTime()){
             t=0
           }
        var convdate=""
        var landpart=total()-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_cp?tripData.extra_cp:0)-(tripData.flight_cp?tripData.flight_cp:0)
        if(t && !notax && !onlyflight && !fdom){
            if(tripData.trip_status=="Converted"){
                convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-1].date:""
            }else if(tripData.trip_status=="Closed"){
              convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-2].date:""
            }
             if(new Date(tripData.trip_start_date).getTime()>=new Date("2026-03-25").getTime()){
                //  landpart=(total()-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_sp?tripData.extra_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))/1.02
                 
                  //return landpart?Math.round((parseInt(landpart))*0.02):0
                  return tripData.land_sp || tripData.cruise_sp?Math.round((parseInt(tripData.land_sp)+parseInt(tripData.cruise_sp))*0.02):0
              }else if(new Date(convdate).getTime()<new Date("2023-04-01").getTime()){
                return 0
              }else if(new Date(convdate).getTime()>new Date("2023-08-15").getTime()){
                //console.log(tripData.cruise_sp)
                return tripData.land_sp || tripData.cruise_sp?Math.round((parseInt(tripData.land_sp)+parseInt(tripData.cruise_sp))*0.05):0
              }else{
                return tripData.land_sp?Math.round((tripData.land_sp)*0.05):0
              }
            //console.log("ABC")
           
            
            //return landpart?Math.round((landpart)*0.05):0
        }else{
            //console.log("DEF")
            //setprice({...price,tcs:0})
            return 0
        }
      }
      

    return ( 
        <div>
        {role && cuser && showpaymentdata?(
            <div>
            
       <Paper variant="outlined" className={classes.paper} elevation={10}>
       <Button variant="outlined" color="inherit"  className={classes.button2} href={"/tripdataentry/"+tripData.trip_id+"/invoice"}> Create Invoice</Button>
       {role=="Admin" || role=="TL" || role=="Operations" || role=="Operations-TL" || role=="Product"  || role=="Accounts"?(
          <div>
          <FormControlLabel control={<Checkbox color="primary"/>}  value={notax} checked={notax} label="Special case?" onChange={(e)=> setnotax(!notax)}/>
          <FormControlLabel control={<Checkbox color="primary"/>}  value={onlyflight} checked={onlyflight} label="Only Flight?" onChange={(e)=> setonlyflight(!onlyflight)}/>
          <FormControlLabel control={<Checkbox color="primary"/>}  value={fdom} checked={fdom} label="Proxy Dom?" onChange={(e)=> setfdom(!fdom)}/>
          </div>
        ):("")}
        <Typography variant="h4" align="center" className={classes.headertext}> Customer Payments (Total:{total()}) || (Pending:{pending()} || Profit:{total()-gettaxes()-sptotal()})</Typography>
        <Typography variant="h6" align="center" className={classes.headertext}> Collect 60% of land part with a month of conversion or before 30days of trip start whichever is sooner</Typography>
        <FormGroup row className={classes.formgroup}>
        <TextField variant="standard" type="Number" label="Flight Price"  InputLabelProps={{ shrink: true }} value={tripData.flight_sp} className={classes.textField2} onChange={(e) => settripData({ ...tripData, flight_sp: e.target.value })}/>
        <TextField variant="standard" type="Number" label="Visa Price"  InputLabelProps={{ shrink: true }} value={tripData.visa_sp} className={classes.textField2} onChange={(e) => settripData({ ...tripData, visa_sp: e.target.value })}/>
        <TextField variant="standard" type="Number" label="Ancilliary Price"  InputLabelProps={{ shrink: true }} value={tripData.anc_sp} className={classes.textField2} onChange={(e) => settripData({ ...tripData, anc_sp: e.target.value })}/>
        <TextField
                    variant="standard"
                    type="Number"
                    label="AC/SIM/Insurance"
                    InputLabelProps={{ shrink: true }}
                    value={tripData.extra_sp}
                    className={classes.textField2}
                    onChange={(e) =>
                      settripData({ ...tripData, extra_sp: e.target.value })
                    }
                  />
        <TextField variant="standard" type="Number" label="Cruise Price"  InputLabelProps={{ shrink: true }} value={tripData.cruise_sp} className={classes.textField2} onChange={(e) => settripData({ ...tripData, cruise_sp: e.target.value })}/>
       
        <TextField variant="standard" type="Number" label="Land Price (incl. taxes)"  InputLabelProps={{ shrink: true }} value={tripData.land_sp} className={classes.textField2} onChange={(e)=>changelandsp(e)}/>
        <TextField
            variant="standard"
           
            label="Taxes"
            InputLabelProps={{ shrink: true }}
            value={gettaxes()}
            className={classes.textField2}
            disabled
          />
          <TextField
            variant="standard"
            disabled
            label="TCS Charged"
            InputLabelProps={{ shrink: true }}
            value={gettcs(tripData)}
            className={classes.textField2}
            
          />
        <TextField disabled variant="standard" label="Total"  InputLabelProps={{ shrink: true }} value={parseInt(tripData.flight_sp)+parseInt(tripData.visa_sp)+parseInt(tripData.anc_sp)+parseInt(tripData.extra_sp)+parseInt(tripData.cruise_sp)+parseInt(tripData.land_sp)+
              gettcs(tripData)} className={classes.textField2} />
        </FormGroup>
        <form onSubmit={handleSubmit}>
       {cpdata.map(item => {
                return <div>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  helperText={"First payment date must match with Converted date otherwise SP will have incentive error"} required label="Date"  inputProps={{ max: fupfinalDate2 }} id={cpdata.indexOf(item)} type="date" InputLabelProps={{ shrink: true }} value={item.date} className={classes.textField} onChange={(e) => datechange(e,e.target.id)}/>
                <TextField variant="standard"  required label="Amount (number)"   id={cpdata.indexOf(item)} value={item.amount} className={classes.textField} onChange={(e) => amountchange(e,e.target.id)}/>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="status">Status *</InputLabel>
                <Select displayEmpty classname={classes.textField}  labelId="status" required  name={cpdata.indexOf(item)} value={item.status} onChange={(e) => statuschange(e,e.target.name)}>
                    <MenuItem value={"Pending"}>Pending</MenuItem>
                        
                </Select>
                </FormControl>  
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="Mode">Mode</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="Mode"  name={cpdata.indexOf(item)} value={item.mode} onChange={(e) => modechange(e,e.target.name)}>
                    <MenuItem value={"NEFT/RTGS"}>NEFT/RTGS</MenuItem>
                    <MenuItem value={"IMPS"}>IMPS</MenuItem>
                    <MenuItem value={"UPI"}>UPI</MenuItem> 
                    <MenuItem value={"App"}>App</MenuItem>
                    <MenuItem value={"Cash"}>Cash</MenuItem>  
                    <MenuItem value={"Others"}>Others</MenuItem>   
                </Select>
                </FormControl>  
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="Account">Account</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="Account"  name={cpdata.indexOf(item)} value={item.account} onChange={(e) => accountchange(e,e.target.name)}>
                    <MenuItem value={"Kotak"}>Kotak</MenuItem>
                    <MenuItem value={"AU"}>AU</MenuItem>
                    <MenuItem value={"IndusInd"}>IndusInd</MenuItem>
                    <MenuItem value={"Axis"}>Axis</MenuItem>
                    <MenuItem value={"Cash"}>Cash</MenuItem>  
                    <MenuItem value={"Others"}>Others</MenuItem>   
                </Select>
                </FormControl> 
                <TextField variant="standard" label="Details"   id={cpdata.indexOf(item)} value={item.details} className={classes.textField} onChange={(e) => detailschange(e,e.target.id)}/>
            </FormGroup>
            <Typography variant="h4" align="center" className={classes.headertext}> ------------------------------------------------------------------------------------------- </Typography>
            </div>})}
           
            <FormGroup row className={classes.formgroup}>
                
                <Button variant="outlined" color="primary"  className={classes.button} onClick={addcp}> + Tranche</Button>
                <Button variant="outlined" color="secondary" className={classes.button} onClick={removecp}> - Tranche</Button>
                
            </FormGroup>
        <FormGroup row className={classes.formgroup}>
        <TextField variant="standard" type="Number" label="Flight Cost"  InputLabelProps={{ shrink: true }} value={tripData.flight_cp} className={classes.textField2} onChange={(e) => settripData({ ...tripData, flight_cp: e.target.value })}/>
        <TextField variant="standard" type="Number" label="Visa Cost"  InputLabelProps={{ shrink: true }} value={tripData.visa_cp} className={classes.textField2} onChange={(e) => settripData({ ...tripData, visa_cp: e.target.value })}/>
        <TextField variant="standard" type="Number" label="Ancilliary Cost"  InputLabelProps={{ shrink: true }} value={tripData.anc_cp} className={classes.textField2} onChange={(e) => settripData({ ...tripData, anc_cp: e.target.value })}/>
          <TextField
                    variant="standard"
                    type="Number"
                    label="AC/SIM/Insurance"
                    InputLabelProps={{ shrink: true }}
                    value={tripData.extra_cp}
                    className={classes.textField2}
                    onChange={(e) =>
                      settripData({ ...tripData, extra_cp: e.target.value })
                    }
                  />
        <TextField variant="standard" type="Number" label="Cruise Cost"  InputLabelProps={{ shrink: true }} value={tripData.cruise_cp} className={classes.textField2} onChange={(e) => settripData({ ...tripData, cruise_cp: e.target.value })}/>
        <TextField variant="standard" type="Number" label="Land Cost"  InputLabelProps={{ shrink: true }} value={tripData.land_cp} className={classes.textField2} onChange={(e) => settripData({ ...tripData, land_cp: e.target.value })}/>
        <TextField disabled variant="standard" label="Total"  InputLabelProps={{ shrink: true }} value={parseInt(tripData.flight_cp)+parseInt(tripData.visa_cp)+parseInt(tripData.anc_cp)+parseInt(tripData.extra_cp)+parseInt(tripData.cruise_cp)+parseInt(tripData.land_cp)} className={classes.textField2} />
        </FormGroup>
          
        <Typography variant="h4" align="center" className={classes.headertext}> Supplier Payments (Total:{sptotal()}) || (Pending:{sppending()})</Typography>
        
       {spdata.map(item => {
                return <div>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="Date"  disabled={role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Accounts"?0:1} required={role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Accounts"?1:0} id={spdata.indexOf(item)} type="date" InputLabelProps={{ shrink: true }} value={item.date} className={classes.textField} onChange={(e) => spdatechange(e,e.target.id)}/>
                <TextField variant="standard"  label="Amount (number)"   disabled={role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Accounts"?0:1} required={role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Accounts"?1:0} id={spdata.indexOf(item)} value={item.amount} className={classes.textField} onChange={(e) => spamountchange(e,e.target.id)}/>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="status">Status *</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="status"  disabled={role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Accounts"?0:1} required={role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Accounts"?1:0} name={spdata.indexOf(item)} value={item.status} onChange={(e) => spstatuschange(e,e.target.name)}>
                    <MenuItem value={"Pending"}>Pending</MenuItem>
                    
                    <MenuItem value={"Refund"}>Refund</MenuItem> 
                       
                </Select>
                </FormControl>  
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="Mode">Mode</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="Mode"  disabled={role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Accounts"?0:1}  name={spdata.indexOf(item)} value={item.mode} onChange={(e) => spmodechange(e,e.target.name)}>
                    <MenuItem value={"NEFT/RTGS"}>NEFT/RTGS</MenuItem>
                    <MenuItem value={"IMPS"}>IMPS</MenuItem>
                    <MenuItem value={"UPI"}>UPI</MenuItem> 
                    <MenuItem value={"App"}>App</MenuItem>
                    <MenuItem value={"Cash"}>Cash</MenuItem>  
                    <MenuItem value={"Others"}>Others</MenuItem>   
                </Select>
                </FormControl>  
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="Account">Account</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="Account"  disabled={role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Accounts"?0:1} name={spdata.indexOf(item)} value={item.account} onChange={(e) => spaccountchange(e,e.target.name)}>
                    <MenuItem value={"Kotak"}>Kotak</MenuItem>
                    <MenuItem value={"IndusInd"}>IndusInd</MenuItem>
                    <MenuItem value={"Axis"}>Axis</MenuItem>
                    <MenuItem value={"AU"}>AU</MenuItem>
                    <MenuItem value={"Cash"}>Cash</MenuItem>  
                    <MenuItem value={"Others"}>Others</MenuItem>   
                </Select>
                </FormControl> 
                <TextField variant="standard" label="Details"   id={spdata.indexOf(item)} disabled={role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Accounts"?0:1} value={item.details} className={classes.textField} onChange={(e) => spdetailschange(e,e.target.id)}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="supplier">Supplier</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="supplier"  disabled={role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Accounts"?0:1} name={spdata.indexOf(item)} value={item.name} onChange={(e) => spnamechange(e,e.target.name)}>
                {sData.map(sup => {
                    return <MenuItem value={sup.supplier_name}>{sup.supplier_name}</MenuItem>})}   
                </Select>
                </FormControl> 
                <TextField
            variant="standard"
           
            label="Supplier Type"
            InputLabelProps={{ shrink: true }}
            value={item.name?getsuppliertype(item.name):""}
            className={classes.textField2}
            disabled
          />
                </FormGroup>
                <Typography variant="h4" align="center" className={classes.headertext}> ------------------------------------------------------------------------------------------- </Typography>
            </div>})}
           
            <FormGroup row className={classes.formgroup}>
                
                <Button variant="outlined" color="primary"  className={classes.button} onClick={addsp}> + Tranche</Button>
                <Button variant="outlined" color="secondary" className={classes.button} onClick={removesp}> - Tranche</Button>
                
            </FormGroup>
            {/* {role=="Admin"?( */}
            <FormGroup row className={classes.formgroup}>
                
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href={"/tripdataentry/"+currentid} variant="contained" color="secondary" className={classes.button}>Cancel</Button>
                
            </FormGroup>
            {/* ):(<div></div>)} */}
            </form>

            </Paper>
            </div>
            ):("Loading...")}
        </div>
     );
}
 
export default Trippayments;